import styled from 'styled-components';

export const TitleWithTooltip = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;
